import { render, staticRenderFns } from "./NewGrid.vue?vue&type=template&id=6b2a3560"
import script from "./NewGrid.vue?vue&type=script&lang=js"
export * from "./NewGrid.vue?vue&type=script&lang=js"
import style0 from "./NewGrid.vue?vue&type=style&index=0&id=6b2a3560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports